import { forwardRef } from 'react';

import { TextOverflow } from '../../../../../../components/TextOverflow';

import { StyledTag } from './styles';

type Props = {
  value: string;
  maxWidth?: string;
};

export const Tag = forwardRef<HTMLDivElement, Props>(({ value, maxWidth }, ref) => {
  return (
    <StyledTag maxWidth={maxWidth} ref={ref}>
      <TextOverflow text={value} showTooltip={!!maxWidth} />
    </StyledTag>
  );
});
